import { usePlanStore } from "../stores/plan-store";

export function usePlans() {
	const { plans, isLoading, isCheckoutLoading, isPortalLoading, error, index, createCheckout, getBillingPortal } = usePlanStore();

	return {
		plans,
		isLoading,
		isCheckoutLoading,
		isPortalLoading,
		error,
		indexPlans: index,
		createCheckout,
		getBillingPortal,
	};
}
